import {createSlice} from '@reduxjs/toolkit'


const initialState = {
    paymentStatus:"",
    paymentPlanStatus:"",
    actualBalance:"",
    merchantStatus : ""
}

export const PaymentStatusSlice = createSlice({
    name : 'PaymentStatus',
    initialState,
    reducers : {
        PaymentStatus : (state,action)=>{
          state.paymentPlanStatus = action.payload.paymentPlanStatus;
          state.paymentStatus = action.payload.paymentStatus;
        state.actualBalance = action.payload.actualBalance;
        state.merchantStatus = action.payload.merchantStatus;


          }
    }
})

export const {PaymentStatus} = PaymentStatusSlice.actions;
export default PaymentStatusSlice.reducer;